import Model from "./model";
import store from '@/store'
import _ from "lodash";

export default new Model({
  resource: "trabajador",
  //para relaciones de 1:1
  //model destino > attr dentro de model destino > attr dentro de model origen(actual)
  // la variable se guarda en la instancia con el nombre del resource del contratoModel
  relations:[["contratoModel", "trabajador_id", "id"]],

  //transforma los datos de contratistas en contratista_id
  //para cada trabajador
  transform:[
    ['contratistas', 'contratistas_id', (item) => {
      return _.map(item.contratistas, c => c.id);
    }]
  ],
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", disabled:true, width:60},
    {label:"Código", nameAttr:"codigo", default:"-", required: true, type:"text", width:60},
    {label:"C. Agro", nameAttr:"compuagro_id", default:"", required:false, type:"text", width: 100},
    {label:"Nombre", nameAttr:"nombre", default:"", required: true, type:"text", width: 300},
    {label:"RUT", nameAttr:"rut", default:"-", required: true, type:"text", width:120},
    {label:"Empresa", nameAttr:"empresa_id", default:null, required: true, type:"select", model:"empresaModel", searchPath:"nombre", width:150,
      mapValueFn:(itemForm, item) => {
        itemForm.list = _.filter(itemForm.list, item => {
          return _.find(store.getters.empresas, {id: item.id})
        })
        return itemForm;
      },
    },
    //{label:"Contratista", nameAttr:"contratistas", default:null, required: true, type:"select", model:"contratistaModel", searchPath:"nombre"},
    {label:"Contratista", nameAttr:"contratistas_id", default:[], required: true, type:"multiSelect", itemText:"nombre", model:"contratistaModel", width:150},
    {label:"Super hombre", nameAttr:"super_hombre", default:false, required: true, type:"checkbox", width:60},


    {label:"ID Contrato", nameAttr:"contrato.id", default:null, required: true, type:"text", modelTo:"contratoModel", disabled: true, width:60},
    //{label:"Trabajador", nameAttr:"trabajador_id", default:null, required: true, type:"select", model:"trabajadorModel"},
    {label:"Campo", nameAttr:"contrato.campo_id", default:null, required: true, type:"select", model:"campoModel", modelTo:"contratoModel", searchPath:"nombre", width:150, defaultFirst: true},
    {label:"Descripción", nameAttr:"contrato.descripcion", default:"-", required: true, type:"text", modelTo:"contratoModel", width:100},
    {label:"$ Hora Extra", nameAttr:"contrato.hora_extra", default:0, required: true, type:"text", modelTo:"contratoModel", width:100},
    {label:"$ Día", nameAttr:"contrato.valor_dia", default:0, required:true, type:"text", modelTo:"contratoModel", width:100},
    {label:"Tipo Contrato", nameAttr:"contrato.tipo_contrato_id", default:null, defaultFirst: true, required: true, type:"select", model:"tipoContratoModel", modelTo:"contratoModel", searchPath:"nombre", width:100},
  ]
});
